module.exports = __webpack_public_path__ + "static/media/BIMpic2.a7096509.png";